import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import SEO from "@/components/base/SEO";
import SchemaOrg from "@/components/base/SchemaOrg";
import Breadcrumb from "@/components/base/Breadcrumb";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleCard from "@/components/feature/ArticleCard";
import { getCategoryBySlug, categories } from "@/mocks/categories";
import { getArticlesByCategory, getBreakingArticles } from "@/mocks/articles";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : undefined;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [slug]);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-16 text-center">
          <h1 className="text-2xl font-bold text-foreground-950">分类未找到</h1>
          <Link to="/" className="text-primary-500 mt-4 inline-block hover:text-primary-600">返回首页</Link>
        </main>
        <Footer />
      </div>
    );
  }

  const catArticles = getArticlesByCategory(category.id);
  const breakingArticles = getBreakingArticles().filter((a) => a.categoryId === category.id);
  const pageTitle = `${category.name} - 黑料吃瓜网`;
  const pageDesc = `${category.description}，黑料吃瓜网为您提供最新${category.name}资讯，每日实时更新。`;
  const pageKeywords = `${category.name},娱乐八卦,明星爆料,黑料吃瓜网,吃瓜热点`;

  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl={`https://heiliachigua.com/category/${category.slug}`}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: pageTitle,
          description: pageDesc,
          url: `https://heiliachigua.com/category/${category.slug}`,
          inLanguage: "zh-CN",
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 pt-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category.name },
              ]}
            />

            <div className="mb-8">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                {category.name}
              </h1>
              <p className="text-foreground-500 mt-2 text-sm">{category.description}</p>
            </div>

            <div className="flex flex-wrap items-center gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    cat.id === category.id
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {breakingArticles.length > 0 && (
              <div className="mb-8 p-4 rounded-lg bg-accent-50/50 border border-accent-100">
                <div className="flex items-center gap-2 mb-4">
                  <span className="px-3 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    重磅
                  </span>
                  <h2 className="text-base font-bold text-foreground-950">本类独家爆料</h2>
                </div>
                {breakingArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
              {catArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>

            {catArticles.length === 0 && (
              <div className="text-center py-16">
                <p className="text-foreground-500">暂无该分类文章，敬请期待~</p>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}